export const DATA_ATTRIBUTE_PREVENT_AG_GRID_ON_ROW_CLICKED = {
  'data-prevent-ag-grid-on-row-clicked': true,
};
